  document.addEventListener("DOMContentLoaded", function() {
    const fancyHeading = document.querySelector('.fancy');
    if (!fancyHeading) return;

    const letters = fancyHeading.textContent.split('');
    const content = letters.map((val) => {
      const delay = Math.floor((Math.random() * 1000) + 1);
      return `<span style="animation-delay: ${delay}ms">${val}</span>`;
    });
    fancyHeading.innerHTML = content.join('');
  });

  window.addEventListener("load", function() {
    const preloader = document.querySelector('.custom-preloader');
    if (!preloader) return;

    // Ensure transition triggers after a short delay
    setTimeout(() => {
      preloader.classList.add('hide');
    }, 500);

    // Optional: remove it from DOM after animation finishes
    setTimeout(() => {
      preloader.remove();
    }, 1600);
  });